import Helper from '@ember/component/helper';

export default class DateNowHelper extends Helper {
  _timeout;
  setInterval(interval) {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
    if (interval) {
      this._timeout = setTimeout(() => this.recompute(), interval);
    }
  }
  compute(params, { interval }) {
    this.setInterval(interval);
    return new Date();
  }
}
